import toast from "react-hot-toast";
import { DocumentType } from "../../../../types/DocumentType";
import { usePatchDocumentPropertiesMutation } from "../../../../services/clientdocuments";

export type PatchDocumentProps = {
    isLoading: boolean,
    patchDocument: (form: JsonPatchDocument) => Promise<DocumentType>
};

export const usePatchDocument = () : PatchDocumentProps => {
    const [mutate, { isLoading }] = usePatchDocumentPropertiesMutation();

    const onPatchHandler = (form: JsonPatchDocument) : Promise<DocumentType> => new Promise<DocumentType>((resolve, reject) => {
        return toast.promise<DocumentType>(mutate({ documentId: form.id, operations: form.operations }).unwrap(), {
            loading: 'Updating document properties...',
            success: 'Document properties have been updated.',
            error: 'Failed to update document properties.'
        }).then(
            (r: DocumentType) => resolve(r),
            (e) => reject(e)
        )
    });

    return {
        isLoading,
        patchDocument: onPatchHandler
    }
};